import React from "react";

import {
  type NumberInputProps as BaseNumberInputProps,
  Unstable_NumberInput as BaseNumberInput,
} from "@mui/base/Unstable_NumberInput";
import classNames from "classnames";

import { ReactComponent as Icon_Minus } from "../../assets/icons/Minus.svg";
import { ReactComponent as Icon_Plus } from "../../assets/icons/Plus.svg";

import style from "./NumberInput.module.css";

export type NumberInputProps = Omit<BaseNumberInputProps, "slotProps" | "slots"> & {
  min: number;
  max: number;
  errorMessage?: string;
};

export const NumberInput = React.forwardRef<HTMLInputElement, NumberInputProps>(
  ({ error, errorMessage, ...props }, ref) => {
    const maxCharacters = Math.max(props.max.toString().length, props.min.toString().length);

    return (
      <div className={classNames(style.wrapper, props.className, props.disabled && style.disabled)}>
        <BaseNumberInput
          slotProps={{
            root: { className: classNames(style.root, (errorMessage || error) && style.error) },
            input: {
              className: style.input,
              maxLength: maxCharacters,
              style: { width: maxCharacters + "ch" },
            },
            incrementButton: {
              className: classNames(style.button, style.incrementButton),
              children: <Icon_Plus />,
              type: "button",
            },
            decrementButton: {
              className: classNames(style.button),
              children: <Icon_Minus />,
              type: "button",
            },
          }}
          {...props}
          ref={ref}
        />
        {errorMessage && <span className={style.errorMessage}>{errorMessage}</span>}
      </div>
    );
  }
);

NumberInput.displayName = "NumberInput";
